module.exports = __webpack_public_path__ + "static/img/putcontent_8.dbb6190.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/putcontent_8.png
// module id = tBKy
// module chunks = 1